export default {
  sponsors: "hasMany"
}



// WEBPACK FOOTER //
// ./src/store/models/event.js